import React from "react";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { CircularProgress, Box, Typography } from "@mui/material";
import Login from "./Login";

const ProtectedRoute = ({ children, allowedUsers }) => {
  const { accounts, inProgress } = useMsal();
  const isAuthenticated = accounts.length > 0;

  if (inProgress === InteractionStatus.Login || inProgress === InteractionStatus.HandleRedirect) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Login />;
  }

  if (allowedUsers && allowedUsers.length > 0) {
    const userEmail = accounts[0]?.username?.toLowerCase();
    if (!allowedUsers.some(email => email.toLowerCase() === userEmail)) {
      return (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <Typography variant="h5" color="error" gutterBottom>
            Acceso Denegado
          </Typography>
          <Typography variant="body1">
            Su cuenta no está autorizada para acceder a esta aplicación.
          </Typography>
          <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
            Usuario: {accounts[0]?.username}
          </Typography>
        </Box>
      );
    }
  }

  return children;
};

export default ProtectedRoute;